module.exports = __webpack_public_path__ + "static/img/6.2c98cd1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/6.png
// module id = +SRo
// module chunks = 0